import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import styled from 'styled-components';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

const CustomHead = ({ headerGroups }) => (
  <>
    {headerGroups.map((headerGroup) => (
      <TableRow {...headerGroup.getHeaderGroupProps()}>
        {headerGroup.headers.map((column) => (
          <TableCell {...column.getHeaderProps()}>
            <StyledDiv>
              <div {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                {column.id !== 'selection' ? (
                  <TableSortLabel
                    active={column.isSorted}
                    direction={column.isSortedDesc ? 'desc' : 'asc'}
                  />
                ) : null}
              </div>
            </StyledDiv>
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);

export default CustomHead;
